import moment from "moment"
export function parseDate(date: string, format = "YYYY-MM-DDThh:mm:ss") {
    return moment(date, format).toDate()
}

export function newGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export interface TestResult {
    test: string,
    isPassed: boolean
}

export const navigateToTracks = (hash: string) => {
    if (isMobile(navigator.userAgent))
        window.location.href = '/mobile' + window.location.hash;
    else
        window.location.href = '/' + window.location.hash;
}

export const isMobile = (useragentString: string): boolean => {
    if (!useragentString)
        return false;

    if (exists("ipad", useragentString)) {
        return false;
    }

    if (exists("android", useragentString) && !exists("mobile", useragentString)) {
        return false;
    }

    if (exists("tablet", useragentString)) {
        return false;
    }

    return exists("mobile", useragentString) || exists("phone", useragentString);
}
function exists(device: string, useragentString: string) {
    return useragentString.toLowerCase().includes(device);
}